import type { ProfileInput } from "@nifgash/shared/validators";
import { api } from "./client";
import type { UserRow } from "./session";

export type ProfilePayload = {
  user: UserRow;
  photo_url: string | null;
  attended: number;
  verified: boolean;
  is_premium: boolean;
};

export async function getProfile(): Promise<ProfilePayload> {
  return api<ProfilePayload>("/api/profile");
}

export type PastEvent = {
  id: string;
  title: string;
  format: string | null;
  city: string | null;
  venue_name: string;
  starts_at: string;
};

export async function getMyHistory(): Promise<{ events: PastEvent[] }> {
  return api<{ events: PastEvent[] }>("/api/profile/history");
}

export async function updateProfile(input: ProfileInput): Promise<UserRow> {
  const res = await api<{ user: UserRow }>("/api/profile", {
    method: "PUT",
    body: JSON.stringify(input),
  });
  return res.user;
}

export async function uploadPhoto(file: File): Promise<{ photo_path: string; photo_url: string | null }> {
  const form = new FormData();
  form.append("photo", file);
  // Don't set Content-Type — browser sets multipart boundary automatically
  return api<{ photo_path: string; photo_url: string | null }>("/api/profile/photo", {
    method: "POST",
    body: form,
  });
}

export type PublicProfilePayload = {
  user: {
    id: string;
    full_name: string | null;
    age: number | null;
    district: string | null;
    interests: string[];
    languages: string[];
  };
  photo_url: string | null;
  attended: number;
  verified: boolean;
};

export async function getPublicProfile(id: string): Promise<PublicProfilePayload> {
  return api<PublicProfilePayload>(`/api/public/users/${id}`);
}
